import { Address } from 'viem';

import { api, cacheTags } from 'modules/api';
import { getPublicClient } from 'modules/api/getPublicClient';
import { getPoolMeta } from 'modules/pool/methods/getPoolMeta';

import { IPoolMeta } from '../types';

interface IGetPoolArgs {
  address: Address;
}

export const {
  useGetPoolMetaQuery,
  endpoints: { getPoolMeta: getPoolMetaEndpoint },
} = api.injectEndpoints({
  endpoints: build => ({
    getPoolMeta: build.query<IPoolMeta | null, IGetPoolArgs>({
      queryFn: async ({ address }) => {
        try {
          const client = getPublicClient();

          return { data: await getPoolMeta(client, address, false) };
        } catch {
          const client = getPublicClient();

          return { data: await getPoolMeta(client, address) };
        }
      },
      providesTags: [cacheTags.poolsMeta],
    }),
  }),
});
